import React, { useCallback } from 'react';
import { useTemplateOrCalculation } from '../../../hooks/useTemplateOrCalculation';
import { useSelector } from 'react-redux';
import { ReduxState } from '../../../store';
import { useGetStatsRegionsQuery } from './apiCalculationStatistics';
import { CalculationStatisticRegionResponse } from '@ydistri/api-sdk';
import StatisticDimensionSection from './components/StatisticDimensionSection';

const SectionRegions: React.FC = () => {
  const templateOrCalculation = useTemplateOrCalculation();
  const departmentId = useSelector((state: ReduxState) => state.statistics.departmentId);
  const { data, isLoading } = useGetStatsRegionsQuery({
    calculationId: templateOrCalculation.id,
    departmentId,
  });

  const getItemTitle = useCallback(
    (item: CalculationStatisticRegionResponse) => item.region.name,
    [],
  );
  const getItemKey = useCallback(
    (item: CalculationStatisticRegionResponse) => `${item.region.id}`,
    [],
  );

  return (
    <StatisticDimensionSection
      title="Regions"
      tableId="region-statistics"
      dimensionColumnTitle="Region"
      data={data}
      loading={isLoading}
      getItemTitle={getItemTitle}
      getItemKey={getItemKey}
    />
  );
};

export default SectionRegions;
